import "./__thumbnail.scss"; import "./news_page.scss"; import "./thumbnail/__dposted.scss"

